import { makeStyles } from '@material-ui/core/styles';


export const borderStyles = makeStyles(({ palette }) => ({
  '@global': {
    '.border-radius-0': {
      borderRadius: '0px !important',
      overflow: 'hidden',
    },
    '.border-radius-4': {
      borderRadius: '4px !important',
      overflow: 'hidden',
    },
    '.border-radius-6': {
      borderRadius: '6px !important',
      overflow: 'hidden',
    },
    '.border-radius-8': {
      borderRadius: '8px !important',
      overflow: 'hidden',
    },
    '.border-radius-12': {
      borderRadius: '12px !important',
      overflow: 'hidden',
    },
    '.border-radius-30': {
      borderRadius: '30px !important',
      overflow: 'hidden',
    },
    '.border-radius-circle': { borderRadius: '50% !important' },
    '.border-none': { border: 'none !important' },
    '.border-transparent': { border: '1px solid transparent !important' },
    '.rounded': {
      borderRadius: '300px !important',
      overflow: 'hidden !important',
    },
    '.rounded-l': {
      borderTopLeftRadius: '300px !important',
      borderBottomLeftRadius: '300px !important',
      overflow: 'hidden !important',
    },
    '.rounded-r': {
      borderTopRightRadius: '300px !important',
      borderBottomRightRadius: '300px !important',
      overflow: 'hidden !important',
    },
    '.border-1-primary': {
      border: '1px solid #103A99'
    },
    '.border-1-grey': {
      border: '1px solid rgba(56, 56, 56, 0.38)'
    },
    '.border-1-light-grey': {
      border: '1px solid #bdbdbd'
    },
    '.border-1-muted': {
      border: '1px solid rgb(224, 224, 224)'
    },
    '.border-1-white': {
      border: '1px solid #ffffff'
    },
    '.border-2-white': {
      border: '2px solid #ffffff'
    },
    '.border-dashed': {
      borderStyle: 'dashed'
    },
    '.border-error': {
      borderColor: `${palette.error.main}`
    }
  },
}));
